module.exports = __webpack_public_path__ + "static/img/2.4.c67eb9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/picture/2.4.jpg
// module id = jfyQ
// module chunks = 7